<div [class.mb-2]="multiSelectTagControl?.value?.length > 0">
  <ng-container *ngIf="options && multiSelectTagControl">
    <div class="tag-container" *ngIf="multiSelectTagControl.value?.length">
      <button
        class="tag no-hover"
        *ngFor="let multiSelectTagControlSelectedOption of multiSelectTagControl.value | idsToMultiSelectOptions : options"
      >
        <label class="tag-label">{{ multiSelectTagControlSelectedOption.label }}</label>
        <button class="tag-close" (click)="removeOption(multiSelectTagControlSelectedOption.id)">
          <svg-icon key="cancel" class="close-icon"></svg-icon>
        </button>
      </button>
    </div>
  </ng-container>
  <osn-cxb-multi-select
    *ngIf="multiSelectTagControl && options"
    [formControl]="multiSelectTagControl"
    [options]="options"
    [allowMultiLine]="false"
    [typeFirstVersion]="true"
    [hasFixedOptions]="false"
    [hintLabel]="hintLabel"
    [filterPlaceholderLabel]="filterPlaceholderLabel"
    [placeholder]="placeholder"
    [filterNoEntriesFoundLabel]="filterNoEntriesFoundLabel"
    [isLoading$]="isLoading$"
  ></osn-cxb-multi-select>
</div>
